import { z } from 'zod';
import { expectType, FeedbackTypesEnum, zDocument, zFeedbackFields } from './model.js';
import { PostTypesEnum } from './post.js';
export const zFeedback = zDocument
    .extend({
    type: z.literal('feedback'),
    user: z.string(),
    document: z.string(),
    documentType: FeedbackTypesEnum,
    topic: z.string(),
    postType: PostTypesEnum
})
    .merge(zFeedbackFields);
expectType({});
expectType({});
export const EmptyFeedback = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'feedback',
    user: '',
    feedback: 0,
    document: '',
    documentType: 'post',
    topic: '',
    postType: 'none'
};
